<!--Desktop view start-->
<div class="listview-header">
  <div class="row d-none d-sm-flex">
    <div class="col-3 col-lg-2">
      <div baseTruncate>
        <span>{{ 'department.singular' | translate }}</span>
        <br />
        <span class="d-lg-none">| {{ 'qualifications.singular' | translate }}</span>
      </div>
    </div>
    <div class="col-2 d-lg-block d-none">
      <div baseTruncate>{{ 'qualifications.singular' | translate }}</div>
    </div>
    <div class="col-2">
      <div baseTruncate>{{ 'start' | translate }}</div>
    </div>
    <div class="col-2 col-lg-1">
      <div baseTruncate>{{ 'demand' | translate }}</div>
    </div>
    <div class="col-2">
      <span baseTruncate>{{ 'inquiry.created' | translate }}</span>
    </div>
    <div class="col-3">
      <div baseTruncate>{{ 'state' | translate }}</div>
    </div>
  </div>
  <!--Desktop view end-->

  <!--Mobile view start-->
  <div class="row d-sm-none">
    <div class="col-5">
      <div baseTruncate>
        <span>{{ 'department.singular' | translate }}</span>
        <br />
        <span>{{ 'qualifications.singular' | translate }}</span>
      </div>
    </div>
    <div class="col-4">
      <div baseTruncate>{{ 'start' | translate }}</div>
    </div>
    <div class="col-3">
      <div baseTruncate>{{ 'state' | translate }}</div>
    </div>
  </div>
</div>
<!--Mobile view end-->
